import * as $ from "jquery";

export default {
	name: 'ModalMultiplePrice',
	props: {
		modalContent: {
			type: Object,
			default: null
		}
	},
	beforeDestroy() {
		this.hideModal();
	},
	methods: {
		show() {
			$(this.$refs.modalMultiplePrice).modal('show');
		},
		hideModal() {
			$(this.$refs.modalMultiplePrice).modal('hide');
		}
	}
}